import { Box, Button } from '@factorialco/deprecated-design-system'

interface ActionsProps {
  journalDraftEntryId: string
  onClickDetail: (journalEntryId: string) => void
}

const Actions = ({ journalDraftEntryId, onClickDetail }: ActionsProps) => {
  return (
    <Box gap="s4" flexDirection="row" justifyContent="flexEnd">
      <Button
        type="secondary"
        onClick={() => onClickDetail(journalDraftEntryId)}
        iconName="arrow-right"
      />
    </Box>
  )
}

export default Actions
